<template>
  <router-link :to="toLocation">
    <article class="avatar">
      <avatar-image :user="user" />
      <section class="description">
        <span class="first-name">
          {{ user.firstName }}
        </span>
        <span class="last-name">
          {{ user.lastName }}
        </span>
      </section>
    </article>
  </router-link>
</template>

<script setup lang="ts">
import AvatarImage from './AvatarImage.vue';
import type { User } from '@/entities/Entities';
import { useLocation } from '@/hooks/location';

interface Props {
  user: User
}
const toLocation = useLocation('/profile');
defineProps<Props>();
</script>

<style lang="scss" scoped>
.avatar {
  @apply text-white;

  display: flex;
  column-gap: px(32);

  .description {
    @apply flex flex-col;
    @apply gap-y-2;

    .first-name {
      font-size: px(18);
      line-height: px(22);
    }
    .last-name {
      font-size: px(24);
      line-height: px(30);
    }
  }
}
</style>
